/** WHAT THE SOURCE DIALOG REMEMBERS, and what it must say out loud.
 *
 *  Owner, 2026-09-27: the source should remember the ticked categories
 *  so he does not have to tick them every time. He asked for it after
 *  being refused twice and re-ticking the same boxes twice.
 *
 *  The one thing a remembered tick must never do is pretend. A commit is
 *  not the commit the ticks were saved against: a category can be absent
 *  from this one entirely, and silently restoring four of six ticks
 *  would hand somebody a smaller source than the one they think they
 *  picked - and the count beside it would agree with the lie. So the
 *  restore returns BOTH: what could be ticked here, and what could not,
 *  for the dialog to print.
 */
export function restoreTicks(remembered, categories) {
  const have = new Set((categories || []).map((c) => String(c && c.category)));
  const want = [...new Set((remembered || []).map(String).filter(Boolean))];
  return {
    picked: want.filter((c) => have.has(c)),
    missing: want.filter((c) => !have.has(c)),
  };
}

/** The sentence for the missing ones. Null when there is nothing to say,
 *  so the caller renders nothing rather than an empty notice. */
export function missingTickNote(missing) {
  const m = (missing || []).filter(Boolean);
  if (!m.length) return null;
  return m.length === 1
    ? `${m[0]} was ticked last time and is not in this commit, so it is not selected.`
    : `${m.length} categories ticked last time are not in this commit, so they are not selected: ${m.join(", ")}.`;
}
